import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import NotificationJobContainer from '../containers/NotificationJob';
import TestNotificationJobDialog from './TestNotificationJobDialog';
import Transition from './Dialogs/Transition';

const styles = {
	row: {
		paddingBottom: 10,
	},
	label: {
		marginRight: 10,
	},
	value: {
		fontWeight: 600,
	},
	current: {},
	new: {
		marginTop: 20,
	},
	section: {
		margin: '30px 0px 10px 0px',
		textAlign: 'left',
	},
	sectionHeader: {
		textTransform: 'uppercase',
		fontSize: 14,
		color: '#777',
		fontWeight: 900,
		letterSpacing: 2,
	},
};

const stylesForClasses = () => ({
	dialogPaper: {
		width: '80%',
	},
});

class ViewNotificationJobDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			newDgsValue: '',
			isTestDialogOpen: false,
			testJobResult: {},
		};
		this.handleShowHistory = this.handleShowHistory.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleEdit = this.handleEdit.bind(this);
		this.handleTestDialogClose = this.handleTestDialogClose.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (
			this.props.open &&
			prevProps.open !== this.props.open &&
			!this.props.notificationHistoryList.length
		) {
			this.props.searchHistory({
				notificationJobId: this.props.notificationJob.notificationJobId,
			});
		}
	}

	handleClose() {
		this.props.onClose();
	}

	handleTestDialogClose() {
		this.setState({ isTestDialogOpen: false });
	}

	handleEdit() {
		this.props.history.push(
			`/notificationJob/update/${this.props.notificationJob.notificationJobId}`
		);
	}

	handleShowHistory(jobResult) {
		this.setState({
			isTestDialogOpen: true,
			testJobResult: jobResult,
		});
	}

	render() {
		const { classes, notificationJob, stationMap, authUser, notificationHistoryList } = this.props;

		if (!notificationJob) {
			return null;
		}

		const stations = notificationJob.stationIds.map((stationId) => {
			return stationMap[stationId];
		});

		const canMakeUpdates = _.get(authUser, ['permissions', 'canMakeUpdates']);
		const canEditPricingNotifications = _.get(authUser, [
			'permissions',
			'canEditPricingNotifications',
		]);

		const historyList = notificationHistoryList.map((r) => {
			r.dateCreatedFormatted = moment(r.dateCreated).format('M/D h:mm a');
			return r;
		});

		return (
			<div>
				<Dialog
					classes={{ paper: classes.dialogPaper }}
					maxWidth="md"
					open={this.props.open}
					TransitionComponent={Transition}
					onClose={this.handleClose}
				>
					<DialogTitle>{notificationJob.name}</DialogTitle>
					<DialogContent>
						<div style={styles.section}>
							<div style={styles.sectionHeader}>Stations</div>
						</div>
						{stations.map((station, i) => {
							return (
								<div key={i} style={styles.row}>
									<span style={styles.label}>
										{station.number} - {station.name}
									</span>
								</div>
							);
						})}

						<div style={styles.section}>
							<div style={styles.sectionHeader}>Emails</div>
						</div>
						{notificationJob.emails.map((email, i) => {
							return (
								<div key={i} style={styles.row}>
									<span style={styles.label}>{email}</span>
								</div>
							);
						})}

						<div style={styles.section}>
							<div style={styles.sectionHeader}>Delivery History</div>
						</div>

						{historyList.length > 0 &&
							historyList.map((history, i) => {
								return (
									<div key={i}>
										<span> Date Sent : {history.dateCreatedFormatted} </span>
										<Button onClick={() => this.handleShowHistory(history.jobResult)}>View</Button>
									</div>
								);
							})}

						{!notificationHistoryList.length && <div>No history yet</div>}
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleClose}>Close</Button>
						{canMakeUpdates && canEditPricingNotifications && (
							<Button variant="contained" onClick={this.handleEdit} color="primary">
								Edit
							</Button>
						)}
					</DialogActions>
				</Dialog>

				<TestNotificationJobDialog
					onClose={this.handleTestDialogClose}
					open={this.state.isTestDialogOpen}
					notificationJob={notificationJob}
					stationMap={stationMap}
					jobResult={this.state.testJobResult}
				/>
			</div>
		);
	}
}

ViewNotificationJobDialog.propTypes = {
	open: PropTypes.bool,
	notificationJob: PropTypes.object,
	stationMap: PropTypes.object.isRequired,
	onClose: PropTypes.func.isRequired,
	history: PropTypes.object,
	authUser: PropTypes.object,
	searchHistory: PropTypes.func.isRequired,
	notificationHistoryList: PropTypes.array,
	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(stylesForClasses), NotificationJobContainer])(
	ViewNotificationJobDialog
);
